import {SeasonName} from '@Libraries/seasons.library';

export const getEndpointForGetUserHasSeenSeasonalBrandkit = (season: SeasonName): string => {
  switch (season) {
    case SeasonName.HALLOWEEN:
      return 'brand/getUserHasSeenHalloweenBrandkitPopover';
    default:
      throw new Error(`Unhandled season ${season}`);
  }
};

export const getEndpointForSetUserHasSeenSeasonalBrandkit = (season: SeasonName): string => {
  switch (season) {
    case SeasonName.HALLOWEEN:
      return 'brand/setUserHasSeenHalloweenBrandkitPopover';
    default:
      throw new Error(`Unhandled season ${season}`);
  }
};

export const getImageFilenameForSeasonalBrandkitPopover = (season: SeasonName): string => {
  switch (season) {
    case SeasonName.HALLOWEEN:
      return 'halloween-brandkit-popover';
    default:
      throw new Error(`Unhandled season ${season}`);
  }
};

export const getTextForSeasonalBrandkitPopover = (season: SeasonName, onlyOneCurrentlyExistingBrandkit: boolean): string => {
  switch (season) {
    case SeasonName.HALLOWEEN:
      return onlyOneCurrentlyExistingBrandkit
        ? window.i18next.t('pmwjs_halloween_brandkit_popover_text_single_brandkit')
        : window.i18next.t('pmwjs_halloween_brandkit_popover_text');
    default:
      throw new Error(`Unhandled season ${season}`);
  }
};
